import { phoneClick } from './gtm';

const TEL_LINK_SELECTOR = 'a[href^="tel:"]';
const TEL_PREFIX = 'tel:';

/**
 * The live `href` is the number that will actually be dialled — `telephone-number-sync`
 * rewrites it whenever call tracking swaps the displayed number, so reading the attribute
 * (rather than the link text) keeps the recorded number and the dialled number in step.
 */
function dialledNumber(link: HTMLAnchorElement): string {
  const href = link.getAttribute('href') ?? '';
  return href.slice(TEL_PREFIX.length).trim() || (link.textContent ?? '').trim();
}

function onDocumentClick(event: Event): void {
  const target = event.target;
  if (!(target instanceof Element)) {
    return;
  }

  const link = target.closest(TEL_LINK_SELECTOR) as HTMLAnchorElement | null;
  if (link) {
    phoneClick(dialledNumber(link));
  }
}

/**
 * One delegated listener for every `tel:` link on the page, including links added after
 * load. Registered on the capture phase so a handler that stops propagation cannot silently
 * drop the conversion. `passive` does nothing for scroll performance on `click` — it is set
 * so this listener can never call `preventDefault()` and suppress the dial.
 */
export function initPhoneClickTracking(): void {
  document.addEventListener('click', onDocumentClick, { capture: true, passive: true });
}
